import React from "react";
import { Link } from "react-router-dom";
import { getIconComponent } from "../../utils/iconHelper";
import "../../styles/homeSections.css";

/**
 * Presentational component to render the homepage section cards grid.
 * @param {Object} props
 * @param {Array} props.sections - Pre-sorted list of section objects.
 */
const HomeSections = ({ sections = [] }) => {
  if (!sections || sections.length === 0) return null;

  return (
    <div className="sections-grid">
      {sections.map((section, idx) => {
        // Safe icon extraction with fallback protection using central utility
        const IconComponent = getIconComponent(section.icon);
        
        // Inline style passing the custom theme color as a CSS variable
        const cardStyle = {
          "--section-theme-color": section.color || "#ff6a00",
        };

        return (
          <Link
            key={section.route || idx}
            to={section.route || "#"}
            className="section-card"
            style={cardStyle}
          >
            {/* Top-left icon badge */}
            <div className="section-card-icon-badge">
              <IconComponent className="section-card-icon" size={24} />
            </div>

            {/* Centered product image illustration */}
            <div className="section-card-image-wrapper">
              {section.image ? (
                <img
                  src={section.image}
                  alt={section.title}
                  className="section-card-image"
                  loading="lazy"
                />
              ) : (
                <div className="section-card-image-placeholder" />
              )}
            </div>

            {/* Info details */}
            <div className="section-card-info">
              <h3 className="section-card-title">{section.title}</h3>
              <p className="section-card-description">{section.description}</p>
              
              <div className="section-card-cta">
                <span>Explore Section</span>
                <span className="section-card-arrow">&rarr;</span>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default HomeSections;
